module.exports = __webpack_public_path__ + "static/media/SwitchOff.6e528fca.svg";